<template>
  <div class="classroom-manage">
    <div class="top-filter">
      <!-- 新的选择学校的方式： -->
      <div class="org_container">
        <p class="org_container_name">{{ schoolSelectName || '- -' }}</p>
        <img
          class="org_container_icon"
          src="https://image.zhihuishu.com/zhs_yufa_150820/b2cm/base1/202307/ddd303c5e801417d820d391216d4e848.png"
          alt="切换"
          @click="switchingSchoolDialogFlag = true"
        />
      </div>
      <div class="right">
        <span @click="exportClassroomList" class="print-btn ZHIHUISHU_QZMD">导出教室列表</span>
        <span @click="toPrintPage" class="print-btn ZHIHUISHU_QZMD">打印二维码</span>
        <span @click="openAddClassroom" class="add-btn ZHIHUISHU_QZMD">+ 新增教室</span>
      </div>
    </div>
    <div class="classroom-container">
      <div class="left-campus">
        <a-tree
          v-if="buildingList.length > 0"
          checkable
          defaultExpandAll
          v-model="checkedKeys"
          :tree-data="buildingList"
          :replaceFields="replaceFields"
          @check="onCheck"
          expandAction="click"
          @select="treeSelect"
        >
          <template #title="{ name, classroomTotal, id }">
            <div class="tree-line" v-if="name" @mouseenter="handleMouseEnter(id)">
              <div class="tree-title" :class="'tree-title-' + id" :title="showDomTitle ? name : undefined">
                {{ name ? name : '' }}
              </div>
              <div class="tree-count">({{ classroomTotal }})</div>
            </div>
          </template>
        </a-tree>
      </div>
      <div class="right-classroom">
        <div class="current-info">
          <span class="current-title">当前选中:</span>
          <span class="current-choose" v-if="showSchoolName">{{ schoolSelectName }}</span>
          <span class="current-choose" v-else>
            <span v-for="(item, index) in currentSelectName" :key="index">
              {{ item }}
              <span v-show="index < currentSelectName.length - 1">、</span>
            </span>
          </span>
        </div>
        <div class="menu-wrapper">
          <div class="left-group">
            <a-select
              class="filter-select"
              default-value="设备绑定：全部"
              option-label-prop="label"
              @change="changeBindingStatus"
              :dropdownStyle="{ textAlign: 'center' }"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <a-select-option value="-1" label="设备绑定：全部">全部</a-select-option>
              <a-select-option value="1" label="设备绑定：已绑定">已绑定</a-select-option>
              <a-select-option value="0" label="设备绑定：未绑定">未绑定</a-select-option>
            </a-select>
            <a-select
              class="filter-select"
              default-value="教室状态：全部"
              option-label-prop="label"
              @change="changeRoomStatus"
              :dropdownStyle="{ textAlign: 'center' }"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode"
            >
              <p slot="title">ddd</p>
              <a-select-option value="-1" label="教室状态：全部">全部</a-select-option>
              <a-select-option value="1" label="教室状态：使用中">使用中</a-select-option>
              <a-select-option value="0" label="教室状态：空闲">空闲</a-select-option>
            </a-select>
            <a-input v-model="searchValue" placeholder="搜索教室名称" @pressEnter="serachEvent">
              <a-icon slot="suffix" type="search" @click="serachEvent" />
            </a-input>
          </div>
          <div class="right-group">
            <span>
              共
              <span>{{ totalCount }}</span>
              间教室，其中
              <span class="unit">{{ useingCount }}</span>
              间正在使用
            </span>
          </div>
        </div>
        <!-- <div v-if="isNoData" class="no-data">
          <img
            src="//image.zhihuishu.com/zhs_yufa_150820/ablecommons/zhangying/202110/c508b9614bd04ddea16797a25e660812.png"
            width="270"
            height="255"
          />
          <span class="no-data-tit">暂无教室管理</span>
        </div> -->
        <div class="table-data">
          <a-table
            @change="tableChangeEvent"
            :columns="columns"
            :data-source="tableData"
            :pagination="false"
            :row-key="(record, index) => index"
            :loading="loading"
          >
            <a slot="name" slot-scope="text">{{ text }}</a>
            <span slot="action" slot-scope="text, record">
              <a-tooltip placement="bottom" overlayClassName="actionTooltipClass">
                <div class="action-tooltip" slot="title">
                  <span class="ZHIHUISHU_QZMD" @click="openEditDialog(record)">查看详情</span>
                  <!-- <span @click="handleAdvancedSetupOpen(record)">高级设置</span> -->
                  <span
                    class="qr-code ZHIHUISHU_QZMD"
                    v-if="record.classroomType != 12"
                    @click="openDeviceQrCodeModel(record)"
                    style="color: #3db166"
                  >
                    二维码绑定
                  </span>
                  <span class="ZHIHUISHU_QZMD" v-show="record.status" @click="quitModelEvent(record)">踢出</span>
                  <span @click="deleteModelEvent(record)" class="delete ZHIHUISHU_QZMD">删除</span>
                </div>
                <div class="action-icon-outer">
                  <img class="action-icon" src="~@/assets/img/more@2x.png" width="4" height="15" />
                </div>
              </a-tooltip>
            </span>
            <span slot="cameraNum" slot-scope="cameraNum">
              {{ cameraNum ? `已绑定(${cameraNum})` : '未绑定' }}
            </span>
            <span :class="status ? 'useing-status' : 'no-useing'" slot="status" slot-scope="status">
              {{ !status ? '空闲' : '使用中' }}
            </span>
            <span slot="classroomType" slot-scope="classroomType, record">
              {{ handleClassroomType(record.classroomType) }}
            </span>
            <span
              class="ZHIHUISHU_QZMD"
              slot="qrAddress"
              slot-scope="qrAddress, record"
              @click="openQrcodeModel(qrAddress, record)"
            >
              <img
                class="qrcode-icon"
                :style="{ cursor: record.classroomType == 12 ? 'not-allowed' : 'pointer' }"
                src="@/assets/img/Shape@2x.png"
                width="20"
                height="20"
              />
            </span>
          </a-table>
          <a-row type="flex" justify="end" style="margin-top: 20px">
            <a-pagination
              show-size-changer
              :default-current="1"
              :page-size-options="pageSizeOptions"
              :total="pagination.total"
              :defaultPageSize="50"
              @change="handlePageChange"
              @showSizeChange="onShowSizeChange"
              v-model="pagination.current"
              :pageSize.sync="pagination.pageSize"
              :show-total="(total) => `共 ${total} 条`"
              style="position: relative"
            >
              <template slot="buildOptionText" slot-scope="props">
                <span>{{ props.value }}条/页</span>
              </template>
            </a-pagination>
          </a-row>
        </div>
      </div>
    </div>

    <QrcodeDialog :showQrcodeModelProp.sync="showQrDialog" :currentRoomData="currentRoomData" :isNewPic="isNewPic" />
    <BindQrDialog
      :showBindQrDialogProp.sync="showBindQrDialog"
      :bindQrData="bindQrData"
      :isShowQrInput="isShowQrInput"
      @handleBindQr="handleBindQr"
      :errTxt="errTxt"
      @handleCancelBindQr="handleCancelBindQr"
    />
    <DelClassroomDialog
      :showDelDialogProp.sync="showDelDialog"
      delTitle="删除教室"
      tipText="确认删除此间教室吗？"
      @handleDel="handleDel"
    />
    <!-- 踢出弹框 -->
    <a-modal
      wrapClassName="customModal bindDeviceClass closeLiveClass"
      centered
      :maskClosable="false"
      :closable="false"
      v-model="closeLiveModel"
      @ok="handleBindDevice"
    >
      <div class="close-live">
        <img
          class="close-icon ZHIHUISHU_QZMD"
          @click="closeLiveModel = false"
          src="~@/assets/img/close@2x.png"
          width="26"
          height="26"
        />
        <img src="../../../assets/img/bulb@2x.png" width="90" height="90" />
        <p class="text">设备正在使用中，确认结束当前直播吗？</p>
      </div>
      <template slot="footer">
        <span @click="closeLiveModel = false" class="btn confirm ZHIHUISHU_QZMD">再想想</span>
        <span @click="quitClassroom" class="btn ZHIHUISHU_QZMD">关闭直播</span>
      </template>
    </a-modal>
    <switching-school
      :switchingSchoolDialogFlag="switchingSchoolDialogFlag"
      @handleSwitchingSchoolDialogClose="handleSwitchingSchoolDialogClose"
    />
    <advanced-setup :advancedSetupOpen.sync="advancedSetupOpen" :advancedSettingDetail="advancedSettingDetail" />
  </div>
</template>
<script>
const columns = [
  {
    title: '教室ID',
    dataIndex: 'classroomCode',
    key: 'classroomCode',
    scopedSlots: { customRender: 'classroomCode' },
    width: 160
  },
  {
    title: '教室编码',
    dataIndex: 'classroomNum',
    key: 'classroomNum',
    scopedSlots: { customRender: 'classroomNum' },
    width: 100
  },
  {
    title: '教学楼',
    dataIndex: 'buildingName',
    key: 'buildingName',
    scopedSlots: { customRender: 'buildingName' },
    ellipsis: true
  },
  {
    title: '教室名称',
    dataIndex: 'classroomName',
    key: 'classroomName',
    scopedSlots: { customRender: 'classroomName' },
    ellipsis: true
  },
  {
    title: '设备绑定',
    dataIndex: 'cameraNum',
    key: 'cameraNum',
    scopedSlots: { customRender: 'cameraNum' },
    ellipsis: true
    // align: 'center'
  },
  {
    title: '教室状态',
    dataIndex: 'status',
    key: 'status',
    scopedSlots: { customRender: 'status' },
    ellipsis: true,
    width: 120,
    align: 'left'
  },
  {
    title: '教室类型',
    dataIndex: 'classroomType',
    key: 'classroomType',
    scopedSlots: { customRender: 'classroomType' },
    ellipsis: true,
    align: 'left'
  },
  {
    title: '二维码',
    dataIndex: 'qrAddress',
    key: 'qrAddress',
    scopedSlots: { customRender: 'qrAddress' },
    ellipsis: true,
    align: 'center'
  },
  {
    title: '操作',
    dataIndex: 'id',
    key: 'action',
    scopedSlots: { customRender: 'action' },
    ellipsis: true,
    class: 'action',
    align: 'center'
  }
]
import ChooseContent from './components/chooseDialog.vue'
import QrcodeDialog from './components/qrcodeDialog.vue'
import BindQrDialog from './components/bindQrcodeDialog.vue'
import DelClassroomDialog from '../BuildingManagement/components/delDailog.vue'
import { mapGetters } from 'vuex'
import { formatDate } from '../../../utils/tool'
export default {
  name: 'ClassRoomManagement',
  components: {
    ChooseContent,
    QrcodeDialog,
    BindQrDialog,
    DelClassroomDialog,
    'switching-school': () => import('@/components/switchingSchool'),
    'advanced-setup': () => import('./components/advancedSetup.vue')
  },
  async created() {},
  activated() {
    this.getClassrooomList()
    this.getClassroomFilterTree()
  },
  data() {
    return {
      schoolList: [],
      selectSchool: '',
      selectSchoolName: '',
      buildingList: [],
      replaceFields: {
        children: 'buildingInfos',
        title: 'name',
        key: 'id'
      },
      checkedKeys: [],
      halfCheckedKeys: [],
      showSchoolName: false,
      selectBuilding: [],
      selectBuildingId: [],
      selectCampus: [],
      selectCampusIdArr: [],
      currentSelectName: [],
      dialogType: 1,
      currentRoomData: {},
      showQrDialog: false, // 二维码弹框
      isNewPic: false, // 是否是新二维码
      showBindQrDialog: false, // 绑定二维码
      bindQrData: {},
      isShowQrInput: false,
      errTxt: '',
      showDelDialog: false, // 删除教室弹框
      searchValue: '', //搜索内容
      bindingStatus: -1,
      roomStatus: -1,
      columns,
      tableData: [
        {
          classroomCode: '',
          classroomName: '',
          cameraNum: '',
          status: '',
          qrAddress: '',
          id: ''
        }
      ],
      pagination: {
        current: 1,
        pageSize: 50,
        total: 0
      },
      pageSizeOptions: ['50', '100', '150', '200'],
      totalCount: 0,
      useingCount: 0,
      provinceList: '',
      classroomDetail: {}, // 教室详情
      closeLiveModel: false,
      isNoData: false,
      loading: false,
      showChooseContent: false,
      showDomTitle: false,
      switchingSchoolDialogFlag: false,
      advancedSetupOpen: false,
      advancedSettingDetail: {}
    }
  },
  computed: {
    ...mapGetters('switchingSchool', ['schoolSelect', 'schoolSelectName'])
  },
  watch: {
    schoolSelect: {
      handler: function (newVal) {
        if (!newVal) return
        this.handleSelectSchool(newVal)
      },
      immediate: true
    }
  },
  methods: {
    treeSelect(s, e) {
      e.node.onExpand()
    },
    emptySelectArr() {
      this.selectCampusIdArr = []
      this.selectCampus = []
      this.selectBuildingId = []
      this.selectBuilding = []
    },
    async handleSelectSchool(value) {
      console.log('value', value)
      this.selectSchool = value
      // this.selectSchoolName = this.schoolList.find(item => item.schoolId == value).schoolName
      this.emptySelectArr()
      this.checkedKeys = []
      this.buildingList = [] // 为了使切换学校后新请求的tree可以默认展开
      this.pagination.current = 1
      await this.getClassroomFilterTree()
      await this.getClassrooomList()
      this.checkedKeys.push(this.selectSchool)
      this.handleAllCheck()
      console.log('this.checkedKeys', this.checkedKeys, this.buildingList)
    },
    // 获取学校教学楼列表
    async getClassroomFilterTree() {
      if (!this.selectSchool) return
      const res = await this.$http.getClassroomFilterTree({
        schoolCode: this.selectSchool
      })
      if (res.code == 200 && res.rt) {
        this.totalClassroomCount = res.rt.classroomSumTotal
        this.buildingList = [
          {
            // name: this.selectSchoolName,
            name: '全部',
            id: this.selectSchool,
            sort: 0,
            classroomTotal: res.rt.classroomSumTotal || 0,
            level: 0,
            buildingInfos: this.handleData(res.rt.campusList, 1)
          }
        ]
      }
    },
    handleData(data, level) {
      data.length &&
        data.forEach((children) => {
          children.level = level
          children.name = children.campusName || children.buildingName || null
          children.id = children.campusId || children.buildingId || null

          children.sort = children.campusSort || children.buildingSort
          if (children.buildingInfos && children.buildingInfos.length) {
            this.handleData(children.buildingInfos, 2)
          }
        })
      return data
    },
    handleAllCheck() {
      this.emptySelectArr()
      this.showSchoolName = true
      this.buildingList[0]?.buildingInfos?.forEach((item) => {
        this.selectCampusIdArr.push(item.id)
        this.selectCampus.push(item.name)
      })
      this.selectCampusIdArr = this.filterArr(this.selectCampusIdArr)
      this.selectCampus = this.filterArr(this.selectCampus)
      this.currentSelectName = [...this.selectCampus]
    },
    filterArr(arr) {
      return arr.filter((item, index) => {
        return arr.indexOf(item) === index
      })
    },
    //获取父节点
    onCheck(checkedKeys, e) {
      this.checkedKeys = checkedKeys
      console.log('this.checkedKeys', this.checkedKeys)
      this.halfCheckedKeys = e.halfCheckedKeys.filter((item) => item != this.selectSchool)
      let checked = e.checked
      let checkData = e.node.dataRef
      let parent = e.node.$parent.dataRef

      const filterSelectBuild = (data) => {
        data?.forEach((item) => {
          this.selectBuildingId = this.selectBuildingId.filter((id) => id != item.id)
          this.selectBuilding = this.selectBuilding.filter((name) => name.indexOf(item.name) < 0)
        })
      }

      // 选中时
      if (checked) {
        this.isNoData = false
        if (this.checkedKeys.length > 0) {
          // 点击楼栋
          if (checkData.level == 2 && this.checkedKeys.includes(checkData.buildingId)) {
            let tempName = parent.campusName + '/' + checkData.buildingName
            // 校区下楼栋没有全部选中
            if (this.halfCheckedKeys.includes(parent.id)) {
              this.selectBuildingId.push(checkData.buildingId)
              this.selectBuilding.push(tempName)
            } else {
              // 全选时需反选，添加校区ID，去除楼栋信息
              this.selectCampusIdArr.push(parent.id)
              this.selectCampus.push(parent.campusName)
              filterSelectBuild(parent.buildingInfos)
            }
          } else if (checkData.level == 1 && this.checkedKeys.includes(checkData.campusId)) {
            // 点击校区
            this.selectCampusIdArr.push(checkData.campusId)
            this.selectCampus.push(checkData.campusName)
            filterSelectBuild(checkData.buildingInfos)
          } else if (checkData.level == 0) {
            this.handleAllCheck()
          }
        }
      } else {
        // 取消选中
        if (checkData.level == 2) {
          // 取消选中楼栋时，对应校区必不会全选，故清除父级ID和名字
          this.selectCampusIdArr = this.selectCampusIdArr.filter((id) => id != parent.id)
          this.selectCampus = this.selectCampus.filter((name) => name != parent.campusName)
          // 拿到该校区下选中的楼栋数据
          parent.buildingInfos?.forEach((item) => {
            if (item.id != checkData.id && this.checkedKeys.includes(item.id)) this.selectBuildingId.push(item.id)
            if (item.name != checkData.name && this.checkedKeys.includes(item.id))
              this.selectBuilding.push(parent.name + '/' + item.name)
          })
          // 去除取消选中的楼栋
          this.selectBuildingId = this.selectBuildingId.filter((id) => id != checkData.id)
          this.selectBuilding = this.selectBuilding.filter((name) => name.indexOf(checkData.buildingName) < 0)
          // 去重
          this.selectBuildingId = this.filterArr(this.selectBuildingId)
          this.selectBuilding = this.filterArr(this.selectBuilding)
        } else if (checkData.level == 1) {
          this.selectCampusIdArr = this.selectCampusIdArr.filter((id) => id != checkData.id)
          this.selectCampus = this.selectCampus.filter((name) => name != checkData.campusName)
        } else if (checkData.level == 0) {
          this.emptySelectArr()
        }
      }
      this.currentSelectName = [...this.selectCampus, ...this.selectBuilding]
      if (!this.checkedKeys.includes(this.selectSchool)) {
        this.showSchoolName = false
      }
      if (this.currentSelectName && this.currentSelectName.length) {
        this.pagination.current = 1
        this.getClassrooomList()
      } else {
        this.tableData = []
        this.totalCount = 0
        this.useingCount = 0
        this.pagination.total = 0
        this.pagination.current = 1
        this.isNoData = true
      }
    },
    async getClassrooomList() {
      this.loading = true
      let _params = {
        schoolCode: this.selectSchool,
        campusIds: this.selectCampusIdArr, // id 数组
        buildingIds: this.selectBuildingId, // 楼栋ID数组
        status: this.roomStatus, //教室状态 -1:全部 0:空闲 1:使用中
        bindingStatus: this.bindingStatus, //	绑定设备 -1:全部 0:未绑定 1:已绑定
        keywords: this.searchValue || '', // 教室名称
        pageNum: this.pagination.current, // 从1开始
        pageSize: this.pagination.pageSize
      }
      try {
        const list = await this.$http.getClassroomList(_params)
        if (list.code === 200 && list.rt.resultStatus == 1) {
          this.loading = false
          this.tableData = list.rt.list
          this.totalCount = list.rt.totalCount
          this.useingCount = list.rt.ext?.inUseClassroomTotal || 0
          this.pagination.total = list.rt.totalCount || 0
          if (!this.searchValue) {
            this.isNoData = list.rt.list.length === 0
          }
        }
      } catch (error) {
        console.log('error', error)
      }
    },
    handlePageChange(page, pageSize) {
      this.pagination.current = page
      this.pagination.pageSize = pageSize
      this.getClassrooomList()
    },
    onShowSizeChange(current, size) {
      this.pagination.current = current
      this.pagination.pageSize = size
      this.getClassrooomList()
    },
    // 新增教室
    openAddClassroom() {
      this.$router.push({
        name: 'ClassroomDetail',
        query: {
          pageType: 1,
          selectSchool: this.selectSchool
        }
      })
    },
    addClassroomUpdate() {
      if (this.dialogType == 1) {
        this.pagination.current = 1
      }
      this.getClassrooomList()
      this.getClassroomFilterTree()
    },
    // 展示二维码弹框
    openQrcodeModel(qrAddress, record) {
      if (record.classroomType == 12) return
      this.currentRoomData.qrAddress = qrAddress
      this.currentRoomData.roomName = record.classroomName
      this.isNewPic = record.newQr
      this.showQrDialog = true
    },
    toPrintPage() {
      this.$router.push({
        name: 'PrintPage',
        params: {
          schoolCode: this.selectSchool,
          campusIds: this.selectCampusIdArr, // id 数组
          buildingIds: this.selectBuildingId, // 楼栋ID数组
          status: this.roomStatus, //教室状态 -1:全部 0:空闲 1:使用中
          bindingStatus: this.bindingStatus, //	绑定设备 -1:全部 0:未绑定 1:已绑定
          keywords: this.searchValue || '' // 教室名称
        }
      })
    },
    // 绑定二维码
    openDeviceQrCodeModel(record) {
      this.bindQrData = record
      this.isShowQrInput = record.bindQrCode ? true : false
      this.showBindQrDialog = true
    },
    handleCancelBindQr() {
      this.errTxt = ''
      this.bindQrData.bindQrCode = ''
      this.showBindQrDialog = false
    },
    async handleBindQr(record) {
      console.log('record', record)
      this.errTxt = ''
      if (!record.bindQrCode) {
        return (this.errTxt = '编号不能为空')
      }
      const params = {
        classCode: this.bindQrData.classroomCode,
        qrCode: record.bindQrCode + ''
      }
      const res = await this.$http.bindQr(params)
      if (res.rt.resultStatus === 1) {
        this.$message.success(res.rt.resultMessage || '保存成功')
        this.showBindQrDialog = false
        this.getClassrooomList()
        this.bindQrData.bindQrCode = ''
      } else {
        this.errTxt = res.rt.resultMessage
      }
    },
    deleteModelEvent(record) {
      this.currentRoomData = record
      this.showDelDialog = true
    },
    handleDel() {
      let _params = {
        id: this.currentRoomData.id,
        schoolId: this.currentRoomData.schoolId
      }
      this.$api.deleteClassrooom(_params).then((res) => {
        if (res.code === 200 && res.rt) {
          this.$message.success('删除成功')
          this.showDelDialog = false
          this.pagination.current = 1
          this.getClassrooomList()
          this.getClassroomFilterTree()
        } else {
          this.$message.error('删除失败')
        }
      })
    },
    // 获取学校列表
    async getSchoolList() {
      // 初始化各项的值
      try {
        let schoolRes = await this.$http.getSelectSchoolList()
        if (schoolRes.code !== 200) {
          throw '初始化学校失败!请稍候重试'
        } else {
          this.schoolList = schoolRes.rt
          console.log('schoolList:>>>>>>>', this.schoolList)
          this.selectSchool = this.schoolList[0]?.schoolId || ''
          this.selectSchoolName = this.schoolList[0]?.schoolName || ''
          await this.getClassroomFilterTree()
          this.buildingList[0]?.buildingInfos.forEach((item) => {
            this.selectCampusIdArr.push(item.id)
            this.selectCampus.push(item.name)
            this.currentSelectName = [...this.selectCampus]
          })
        }
      } catch (error) {
        // this.$message.error(error)
      }
    },
    // 跳转教室详情页
    openEditDialog(record) {
      this.$router.push({
        name: 'ClassroomDetail',
        query: {
          pageType: 2,
          id: record.id,
          selectSchool: this.selectSchool,
          classroomCode: record.classroomCode
        }
      })
      // localStorage.setItem('currentClassroom', JSON.stringify(record))
    },
    changeBindingStatus(v) {
      this.bindingStatus = v
      if (!this.currentSelectName.length) return
      this.pagination.current = 1
      this.getClassrooomList()
    },
    // 踢出
    quitModelEvent(record) {
      this.currentRoomData = record
      this.closeLiveModel = true
    },
    quitClassroom() {
      let _params = {
        classroomCode: this.currentRoomData.classroomCode
      }
      this.$api.quitClassroom(_params).then((res) => {
        if (res.code === 200) {
          this.closeLiveModel = false
          this.getClassrooomList()
        }
      })
    },
    changeRoomStatus(v) {
      this.roomStatus = v
      if (!this.currentSelectName.length) return
      this.pagination.current = 1
      this.getClassrooomList()
    },
    handleBindDevice() {},
    serachEvent() {
      if (!this.currentSelectName.length) return
      this.pagination.current = 1
      this.getClassrooomList()
    },
    tableChangeEvent(pagination) {
      this.pagination.current = pagination.current
      this.getClassrooomList()
    },
    handleMouseEnter(id) {
      const currentDom = document.getElementsByClassName(`tree-title-${id}`)
      let textWidth = currentDom[0].scrollWidth || 0
      let domWidth = currentDom[0].clientWidth || 0
      if (textWidth > domWidth) {
        this.showDomTitle = true
      } else {
        this.showDomTitle = false
      }
    },
    handleSwitchingSchoolDialogClose() {
      this.switchingSchoolDialogFlag = false
    },
    async handleAdvancedSetupOpen({ id }) {
      try {
        this.advancedSetupOpen = true
        const result = await this.$http.advancedSettingQuery({ id })
        this.advancedSettingDetail = { ...(result.rt || {}), id }
      } catch (err) {
        console.log(err)
      }
    },
    // 导出教室列表
    async exportClassroomList() {
      // window.location.href =
      //   process.env.VUE_APP_BASE_URL + '/admin/classroom/exportClassroom?schoolCode=' + this.selectSchool
      const data = await this.$http.exportClassroomList({
        schoolCode: this.selectSchool
      })
      console.log('导出🔧:>>>>>>>', data, 'index.vue')
      if (data?.rt?.resultStatus == -1) {
        return this.$message.warning('导出发生错误!')
      }
      const blob = new Blob([data], {
        type: 'application/vnd.ms-excel'
      })
      const objectUrl = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = objectUrl
      const date = formatDate(new Date(), 'YYYYMMDD')
      a.download = `教室信息-${date}.xlsx`
      a.click()
      document.body.removeChild(a)
    },
    // 处理教室类型
    handleClassroomType(type) {
      let res = ''
      switch (Number(type)) {
        case 1:
          res = '沉浸式教室'
          break
        case 12:
          res = '全景教室'
          break
        case 13:
          res = '极简教室'
          break
        case 14:
          res = '智慧教室'
          break
        default:
          break
      }
      return res
    }
  }
}
</script>
<style lang="scss" scoped>
$primay-color: #5f60d3;

::v-deep .filter-select .ant-select-selection--single {
  height: 32px;
  width: 160px;
}
::v-deep .filter-select .top-filter .ant-select-selection--single {
  height: 32px;
  width: 200px;
}
::v-deep .filter-select .ant-select-selection__rendered {
  line-height: 32px;
}
.classroom-manage {
  // min-height: 996px;
  height: auto;
  min-height: calc(100vh - 56px - 40px);
  text-align: left;
  // background: #fff;
  // padding-top: 10px;
  // box-shadow: 0 0 10px #ddd;
  border-radius: 10px;
  .no-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
    min-height: 400px;
    .no-data-tit {
      margin-top: 20px;
      font-size: 14px;
      color: #231815;
    }
  }

  .table-data {
    padding: 0 16px 16px;
    .qrcode-icon {
      cursor: pointer;
    }
    .useing-status {
      position: relative;
      padding-left: 20px;
      &::before {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        position: absolute;
        left: 0;
        top: 5px;
        border-radius: 50%;
        background: #00cf96;
      }
    }
    .no-useing {
      position: relative;
      padding-left: 20px;
      &::before {
        content: '';
        display: block;
        width: 8px;
        height: 8px;
        position: absolute;
        left: 0;
        top: 5px;
        border-radius: 50%;
        background: #dcdee0;
      }
    }
    ::v-deep {
      .ant-table-thead > tr > th,
      .ant-table-tbody > tr > td {
        border-bottom: 0;
      }
      .ant-table-thead > tr > th {
        background: #f6f6f6;
      }
      .ant-table-tbody {
        tr:nth-child(even) {
          background: #f4f7fa;
        }
      }
      .action {
        text-align: center;
        .action-icon-outer {
          width: 30px;
          height: 20px;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
        }
        .action-icon {
          cursor: pointer;
        }
      }
      .ant-table-pagination {
        float: none;
        text-align: center;
      }
    }
  }
}
.top-filter {
  width: 100%;
  height: 70px;
  padding-left: 16px;
  padding-right: 16px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .org_container {
    display: flex;
    align-items: center;
    .org_container_name {
      font-size: 14px;
      color: #1e2228;
      margin-right: 8px;
    }
    .org_container_icon {
      width: 16px;
      height: 16px;
      display: block;
      cursor: pointer;
      user-select: none;
    }
  }
  .right {
    display: flex;
    .print-btn,
    .add-btn {
      flex-shrink: 0;
      width: 112px;
      height: 38px;
      line-height: 38px;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #ededed;
      font-size: 16px;
      cursor: pointer;
    }
    .print-btn {
      margin-right: 20px;
      color: $primay-color;
      border-color: $primay-color;
    }
    .add-btn {
      background: $primay-color;
      border: 1px solid $primay-color;
      color: #fff;
    }
  }
}
.choose-box {
  width: 600px;
  padding: 20px;
  background: #fff;
}
.classroom-container {
  display: flex;
  background: #fff;
  margin-top: 16px;
  height: auto;
  min-height: calc(100vh - 56px - 40px - 70px - 16px);
  .left-campus {
    width: 220px;
    overflow-x: hidden;
    ::v-deep.ant-tree {
      margin-left: -20px;
    }
    ::v-deep.ant-tree-node-content-wrapper:hover,
    ::v-deep.ant-tree-node-content-wrapper.ant-tree-node-selected {
      background-color: #fff;
    }
    ::v-deep.ant-tree-checkbox-checked .ant-tree-checkbox-inner {
      background-color: #5f60d3;
      border-color: #5f60d3;
    }
    ::v-deep.ant-tree-checkbox-indeterminate .ant-tree-checkbox-inner::after {
      background-color: #5f60d3;
    }
  }
  .tree-line {
    display: flex;
    align-items: center;
    font-size: 14px;
    .tree-title {
      max-width: 100px;
      color: #1e2228;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .tree-count {
      margin-left: 3px;
      color: #9ca5b1;
    }
  }
}
.right-classroom {
  width: calc(100% - 220px);
  border-left: 1px solid #eaeced;
  .current-info {
    display: flex;
    height: 52px;
    line-height: 52px;
    padding: 0 16px;
    border-bottom: 1px solid #eaeced;
    .current-title {
      width: 62px;
      font-size: 14px;
      font-weight: 600;
      color: #000;
    }
    .current-choose {
      flex: 1;
      margin-left: 4px;
      height: 52px;
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .menu-wrapper {
    display: flex;
    padding: 16px;
    justify-content: space-between;
    align-items: center;
    .left-group {
      display: flex;
      align-items: center;
      position: relative;
      .room-count {
        margin-right: 10px;
      }
      .ant-select {
        margin-right: 20px;
        width: 174px;
      }
    }
    .right-group {
      font-size: 14px;
      color: #9ca5b1;
    }
    .unit {
      color: $primay-color;
    }
  }
}
::v-deep {
  .ant-select-dropdown {
    text-align: center;
  }
  .ant-tree li .ant-tree-node-content-wrapper:hover,
  .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background-color: #fff;
  }
  .bindDeviceClass {
    .ant-modal {
      width: 640px !important;
      height: 505px;
      padding-bottom: 0;
      .ant-modal-content {
        height: 505px;
        .ant-modal-header {
          border-bottom: 0;
          padding: 40px 40px 17px;
          .ant-modal-title {
            display: flex;
            align-items: center;
            .tit {
              flex: 1;
              font-size: 22px;
            }
            .header-group {
              .ant-input-affix-wrapper {
                width: 212px;
              }
              img {
                cursor: pointer;
                margin-left: 20px;
              }
            }
          }
        }
        .ant-modal-body {
          padding: 0 40px;
          .device-bind {
            margin-bottom: 20px;
            padding: 24px 20px 20px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            height: 169px;
            .tit {
              margin-bottom: 23px;
              font-size: 18px;
              color: #2b2f3b;
            }
            .device-group {
              display: flex;
              flex-wrap: wrap;
              overflow-y: scroll;
              height: 90px;
              .item {
                display: flex;
                align-items: center;
                height: 34px;
                margin: 0 20px 10px 0;
                padding: 0 10px 0 20px;
                border-radius: 20px;
                border: 1px solid #d4d4d4;
                img {
                  cursor: pointer;
                }
              }
            }
          }
          .tabs-card {
            display: flex;
            align-items: center;
            .tab {
              width: 104px;
              height: 44px;
              line-height: 44px;
              text-align: center;
              background: #f6f6f6;
              border-radius: 8px 8px 0px 0px;
              color: #333;
              cursor: pointer;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
              &.active {
                background: #fff;
                color: #3db166;
                // box-shadow: none;
              }
            }
          }
          .device-list {
            margin-bottom: 20px;
            padding: 20px;
            box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.05);
            border-radius: 8px;
            height: 280px;
            overflow-x: hidden;
            overflow-y: scroll;
            .tit {
              display: flex;
              margin: 0 20px 20px 30px;
              font-size: 14px;
              span {
                flex: 1;
              }
            }
            .device-item {
              display: flex;
              margin-bottom: 30px;
              .ant-checkbox-wrapper,
              .ant-checkbox,
              .ant-checkbox-input,
              .ant-checkbox-inner {
                width: 20px;
                height: 20px;
              }
              .device-info {
                // user-select: none;
                margin-left: 10px;
                width: 100%;
                display: flex;
                .num {
                  width: 257px;
                }
                .name {
                  width: 297px;
                }
              }
            }
          }
        }
        .ant-modal-footer {
          display: flex;
          justify-content: center;
          border-top: 0;
          padding: 0;
          .btn {
            text-align: center;
            width: 88px;
            height: 32px;
            line-height: 32px;
            border-radius: 16px;
            border: 1px solid #d4d4d4;
            cursor: pointer;
            &.confirm {
              margin-left: 24px;
              background: #3db166;
              border: 1px solid #3db166;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .closeLiveClass {
    .ant-modal {
      width: 360px !important;
      height: 272px;
      padding-bottom: 0;
      .ant-modal-content {
        position: relative;
        height: 272px;
        .ant-modal-body {
          padding: 0 32px;
        }
        .close-live {
          margin-bottom: 40px;
          padding-top: 46px;
          text-align: center;
          .text {
            font-size: 16px;
            margin-top: 20px;
            color: #354052;
          }
          .close-icon {
            position: absolute;
            top: 12px;
            right: 12px;
            cursor: pointer;
          }
        }
      }
      .ant-modal-footer {
        .confirm {
          margin: 0 24px 0 0 !important;
        }
      }
    }
  }
}
</style>
